import { useEffect } from 'preact/hooks'
import { useSearchspringContext } from 'libs/searchspring/fetchers/provider'
import { SearchPageLink } from 'libs/searchspring/components/quick-search/SearchPageLink'

/**
 *
 * @typedef defaultSuggestions
 * @type {suggestion[]}
 *
 * @typedef suggestion
 * @property {string} title
 * @property {string} url
 */

export function QuickSearchSuggestions({ query, defaultSuggestions }) {
  const { results, refine } = useSearchspringContext()

  useEffect(() => {
    if (query) {
      refine('query', query)
    }
  }, [query])

  if ((results?.items?.length ?? 0) === 0 && !defaultSuggestions?.length) return null

  const displaySuggestions = [...(results?.items || [])]

  if (defaultSuggestions?.length && displaySuggestions.length === 0) {
    displaySuggestions.push(...defaultSuggestions.slice(0, 4))
  }

  return (
    <div className="flex flex-col gap-y-1 w-full">
      {displaySuggestions.map((suggestion, index) => {
        if (suggestion.query !== undefined) {
          return (
            <SearchPageLink
              key={`result-${index}`}
              query={suggestion.query}
              className="group flex w-fit link-fade"
            >
              <span className="paragraph-xs capitalize">
                {suggestion.label}
              </span>
            </SearchPageLink>
          )
        } else {
          return (
            <SearchPageLink
              key={`default-${index}`}
              url={suggestion.url}
              className="group flex w-fit link-fade"
            >
              <span className="paragraph-xs capitalize">
                {suggestion.title}
              </span>
            </SearchPageLink>
          )
        }
      })}
    </div>
  )
}
